
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import Notificacion from './Item.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { Notificacion }
    } )
    export default class Componente extends Vue {

        constructor() {
            super();
            this.$EventBus.Notificaciones.Error = this.Error;
            this.$EventBus.Notificaciones.Info = this.Info;
            this.$EventBus.Notificaciones.Completado = this.Completado;
            this.$EventBus.Notificaciones.Alerta = this.Alerta;
        }

        public Notificaciones: Array<{ Mensaje: string, Tipo: 'error' | 'success' | 'info' | 'warning'; }> = [];
        public async Agregar( Mensaje: string, Tipo: 'error' | 'success' | 'info' | 'warning' ) {
            this.Notificaciones.push( { Mensaje: Mensaje, Tipo: Tipo } );
        }

        public Error( Mensaje: string ) { this.Agregar( Mensaje, 'error' ); };
        public Completado( Mensaje: string ) { this.Agregar( Mensaje, 'success' ); };
        public Info( Mensaje: string ) { this.Agregar( Mensaje, 'info' ); };
        public Alerta( Mensaje: string ) { this.Agregar( Mensaje, 'warning' ); };


    }
